export const SuperAdminUsersEmail = [
  'test.mentor02@mcast.edu.mt',
  'test.researcher@mcast.edu.mt',
  'otis.researcher@mcast.edu.mt',
  'otis.counsellor@mcast.edu.mt',
]